module.exports = __webpack_public_path__ + "static/media/mastercard.f7ac102f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/mastercard.svg
// module id = 1081
// module chunks = 0